import { render, staticRenderFns } from "./WidgetKPIs.vue?vue&type=template&id=6f99dc8c&scoped=true&"
import script from "./WidgetKPIs.vue?vue&type=script&lang=js&"
export * from "./WidgetKPIs.vue?vue&type=script&lang=js&"
import style0 from "./WidgetKPIs.vue?vue&type=style&index=0&id=6f99dc8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99dc8c",
  null
  
)

export default component.exports